webpackJsonp([1],{

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_jump_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_lodash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utility_api_client__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_constant_home__ = __webpack_require__(56);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.jump = __WEBPACK_IMPORTED_MODULE_6__node_modules_jump_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_7__node_modules_lodash___default.a;
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utility_api_client__["a" /* apiSetting */])({
  CONST: __WEBPACK_IMPORTED_MODULE_9__config_constant_home__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB6uiTwF7zy14ArRx7PG4lXUG3bKLvXl_Y',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: 'blue',
  accent: 'pink',
  warn: 'deep-orange',
  background: 'white'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    GlobalHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a,
    GlobalFooter: __WEBPACK_IMPORTED_MODULE_1__components_footer___default.a
  },
  data: function data() {
    return {
      currentSection: 1
    };
  },


  methods: {
    handleCurrentUpdate: function handleCurrentUpdate(nextValue) {
      this.currentSection = nextValue;
    }
  }
});

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer',
  props: [],
  data: function data() {
    return {
      year: 2017
    };
  },
  mounted: function mounted() {
    this.year = new Date().getFullYear();
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'globalHeader',
  props: ['currentSection'],
  data: function data() {
    return {
      logo: {
        target: '#jsTargetTop'
      },
      navItems: [{
        label: 'トップ',
        target: '#jsTargetTop'
      }, {
        label: '当店について',
        target: '#jsTargetAbout'
      }, {
        label: 'おみやげ',
        target: '#jsTargetShop'
      }, {
        label: '会社概要',
        target: '#jsTargetCompany'
      }, {
        label: 'アクセス',
        target: '#jsTargetAccess'
      }, {
        label: 'お問い合わせ',
        target: '#jsTargetContact'
      }],
      isOpen: false
    };
  },


  computed: {
    headerClass: function headerClass() {
      var self = this;
      var evenOdd = self.currentSection % 2 !== 0 ? 'is-odd' : 'is-even';
      var openClose = self.isOpen ? ' is-open' : ' ';
      return evenOdd + openClose;
    }
  },

  mounted: function mounted() {},


  methods: {
    handleMove: function handleMove(target) {
      var _this = this;

      this._.throttle(function () {
        _this.jump(target, {
          duration: 500,
          offset: 0
        });
      }, 500)();
    },
    handleToggleMenu: function handleToggleMenu() {
      var self = this;
      self.isOpen = !self.isOpen;
    }
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constant_home__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_api_client__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      config: {
        img: {
          section1: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_1,
          section2: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_2,
          section3: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_3,
          // section4: CONST.URL.ASSETS.IMG.BG_SECTION_4,
          section5: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_5,
          section6: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_6,
          section7: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.BG_SECTION_7
        },
        map: {
          mapType: 'roadmap',
          center: {
            lat: 37.606173,
            lng: 140.357114
          },
          maker: {
            pos: { lat: 37.606173, lng: 140.357114 }
          },
          options: {
            mapTypeControl: false
          }
        },
        contact: {
          to: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].CONTACT.TO,
          types: [{
            id: 'shopType',
            label: 'お土産について'
          }, {
            id: 'elseType',
            label: 'その他'
          }]
        }
      },
      shopItems: [{
        img: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.SHOP_ITEM_1,
        url: 'https://satobussanec.base.shop/items/45842956',
        name: '福島の温泉たまご「とろんたま」'
      }, {
        img: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].URL.ASSETS.IMG.SHOP_ITEM_2,
        url: 'https://satobussanec.base.shop/items/45843245',
        name: '福島県産熟成醤油使用　温泉たまごのたれ'
      }],
      contact: {
        type: {
          value: 'shopType'
        },
        email: {
          value: '',
          invalid: {
            format: false,
            require: false
          }
        },
        content: {
          value: '',
          invalid: {
            require: false
          }
        },
        isProgress: false,
        isInvalid: true,
        isAlreadyLimit: false
      },
      btnTop: {
        isShow: false
      },
      alertMessages: [],
      isLoaded: false,
      isOver: {
        section1: true,
        section2: false,
        section3: false,
        section4: false,
        section5: false,
        section6: false,
        section7: false
      }
    };
  },


  computed: {
    mailTo: function mailTo() {
      var self = this;
      var type = self.getTypeLabel() || '';
      var content = self.contact.content.value || '';
      return ['mailto:', __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].CONTACT.TO, '?', 'subject=\u3010\u4F50\u85E4\u7269\u7523\u9928HP\u304A\u554F\u3044\u5408\u308F\u305B\u3011 ' + type, '&body=' + content].join('');
    },
    submitDisable: function submitDisable() {
      var self = this;
      return self.contact.isAlreadyLimit || self.contact.isInvalid || self.contact.isProgress;
    }
  },

  created: function created() {
    var self = this;
    // お問い合わせの送信上限チェック
    var lastTime = localStorage.getItem('lastContactTime');
    var dayTime = 86400000;
    var currentTime = self._.now();
    if (!self._.isNull(lastTime) && parseInt(lastTime, 10) >= currentTime - dayTime) {
      self.contact.isAlreadyLimit = true;
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    var self = this;

    // 各セクションの高さ取得
    self.posYList = {};
    self._.times(self._.size(self.isOver), function (idx) {
      var num = idx + 1;
      if (num === 4) {
        return;
      }
      var key = 'section' + num;
      self.posYList[key] = self.$refs[key].offsetTop;
    });

    setTimeout(function () {
      self.isLoaded = true;
    }, 1000);

    window.addEventListener('scroll', self.handleScroll.bind(self));
  },

  methods: {
    handleMove: function handleMove(target) {
      var _this = this;

      this._.throttle(function () {
        _this.jump(target, {
          duration: 800,
          offset: 0
        });
      }, 500)();
    },
    handleScroll: function handleScroll() {
      var _this2 = this;

      this._.throttle(function () {
        var self = _this2;
        if (window.pageYOffset + 10 > window.innerHeight) {
          self.btnTop.isShow = true;
        } else {
          self.btnTop.isShow = false;
        }

        // 各セクションを通り過ぎたか判定
        var currentTop = window.pageYOffset;
        var currentBottom = window.pageYOffset + window.innerHeight;
        var isAlreadyMatch = false;
        var times = self._.size(self.isOver);
        self._.times(times, function (idx) {
          var num = idx + 1;
          var nextNum = num + 1;
          var key = 'section' + num;
          var nextKey = 'section' + nextNum;
          if (!isAlreadyMatch && currentTop >= self.posYList[key] && (nextNum > times || currentTop < self.posYList[nextKey])) {
            // self.$emit('currentUpdate', num);
            isAlreadyMatch = true;
          }

          if (!self.isOver[key] && currentBottom > self.posYList[key]) {
            self.isOver[key] = true;
          }
        });
      }, 300)();
    },
    handleEmailValid: function handleEmailValid() {
      var _this3 = this;

      this._.debounce(function () {
        _this3.contact.email.invalid.format = !_this3.validEmail(_this3.contact.email.value);
        _this3.contact.email.invalid.require = !_this3.validRequire(_this3.contact.email.value);
        _this3.contact.isInvalid = _this3.getInvalid();
      }, 300);
    },
    handleContentValid: function handleContentValid() {
      var _this4 = this;

      this._.debounce(function () {
        _this4.contact.content.invalid.require = !_this4.validRequire(_this4.contact.content.value);
        _this4.contact.isInvalid = _this4.getInvalid();
      }, 300);
    },
    handleSend: function handleSend() {
      var _this5 = this;

      this._.debounce(function () {
        var self = _this5;
        _this5.manageValid(function () {
          self.contact.isProgress = true;

          var jTypes = self.getTypeLabel();
          var params = {
            email: self.contact.email.value,
            type: jTypes,
            content: self.contact.content.value,
            user_agent: window.navigator.userAgent,
            country: window.navigator.language,
            page_type: 'home'
          };

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_api_client__["b" /* default */])({
            url: __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].API.CONTACT,
            method: 'post',
            data: params
          }).then(function () {
            self.alertMessages = ['送信が完了しました。', 'お問い合わせありがとうございます。'];
            self.$refs.snackbar.open();
            self.contact.isProgress = false;

            // 最後の送信日を保持
            var lastDate = self._.now();
            localStorage.setItem('lastContactTime', lastDate);
            self.contact.isAlreadyLimit = true;
          }).catch(function () {
            self.alertMessages = ['送信が失敗しました。', ['お手数ですが、下記アドレスに送信をお願いします。', __WEBPACK_IMPORTED_MODULE_0__config_constant_home__["a" /* default */].CONTACT.TO].join('')];
            self.$refs.snackbar.open();
            self.contact.isProgress = false;
          });
        });
      }, 500);
    },
    manageValid: function manageValid(callback) {
      this.handleEmailValid();
      this.handleContentValid();

      if (this.getInvalid()) {
        // アラート
        return;
      }

      callback();
    },
    validEmail: function validEmail(pattern) {
      var reg = /^([a-zA-Z0-9])+([a-zA-Z0-9¥._-])*@([a-zA-Z0-9_-]+\.)+([a-zA-Z0-9¥._-]+)+$/;
      return !!reg.test(pattern);
    },
    validRequire: function validRequire(pattern) {
      return !self._.isEmpty(self._.trim(pattern));
    },
    getInvalid: function getInvalid() {
      return [this.contact.email.invalid.format, this.contact.email.invalid.require, this.contact.content.invalid.require, !this.validRequire(this.contact.email.value), !this.validRequire(this.contact.content.value)].some(function (item) {
        return item;
      });
    },
    getTypeLabel: function getTypeLabel() {
      var self = this;
      return self._.find(self.config.contact.types, { id: self.contact.type.value }).label;
    }
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(254),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "l-header",
    class: _vm.headerClass
  }, [_c('md-button', {
    staticClass: "l-header__logo",
    class: (_vm.currentSection === 1) ? "is-current" : "",
    on: {
      "click": function($event) {
        return _vm.handleMove(_vm.logo.target)
      }
    }
  }, [_c('h1', {
    staticClass: "l-header__logo-wrap"
  }, [_c('div', {
    staticClass: "l-header__logo-sub"
  }, [_vm._v("あだたら高原")]), _c('div', {
    staticClass: "l-header__logo-main"
  }, [_c('svg', {
    staticClass: "l-header__logo-icon",
    attrs: {
      "width": "180px",
      "height": "233px",
      "viewBox": "0 0 180 233",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "path-1",
      "d": "M47.6402223,0.982370047 L58.3038089,0.982370047 L65.7492097,3.69566952 L73.5812687,7.70353034 L78.5081863,13.5219925 L83.7912756,22.4865138 L86.9931028,29.8887874 L88.1359752,34.9941626 L90.9117348,34.9941626 L90.9117348,31.9782287 L93.0264577,26.5977313 L95.6542462,21.009777 L101.267482,13.5219925 L106.501495,7.70353034 L113.10294,2.83907292 L124.295951,0.982370047 L134.930539,2.83907292 L144.561302,11.9761033 L148.194402,17.3551135 L149.018281,24.5194436 L148.194402,30.7580247 L145.983014,36.4277722 L139.821765,44.258344 L131.288516,49.6760201 L118.655203,53.6422408 L178.39538,53.6422408 L178.39538,232.045585 L0.309542359,231.255166 L0.309542359,53.6422408 L59.8043401,54.9680322 L59.8043401,53.6422408 L55.1242889,52.338013 L46.5836044,48.6536066 L39.0846663,43.0879594 L33.9398817,37.8665868 L31.4080142,33.76801 L30.5291104,30.7580247 L30.5291104,26.5977313 L30.5291104,21.009777 L32.353096,14.4997915 L37.3848575,7.70353034 L47.6402223,0.982370047 Z M10.6764432,63.4150265 L9.8451281,221.535174 L168.626312,221.535174 L168.626312,63.4150265 L10.6764432,63.4150265 Z M132.590513,121.645006 L103.978551,122.818365 L101.485349,120.308804 L102.603684,114.949871 L97.6076136,109.803599 L92.1802711,107.842052 L85.4197014,108.949233 L81.8185753,110.628965 L79.5246512,113.355649 L78.4806741,116.264508 L78.4806741,121.645006 L79.5246512,125.336848 L88.7152189,128.817515 L97.6076136,129.678573 L103.978551,131.893678 L119.075322,141.884331 L127.578085,151.673475 L130.411099,161.122807 L131.258773,180.182825 L127.578085,191.041227 L121.769289,200.799142 L114.473346,206.712038 L111.859686,206.712038 L114.473346,203.290113 L107.543985,206.712038 L98.7133073,211.236682 L78.4806741,211.236682 L68.3294096,210.281934 L62.1034692,208.099546 L55.9756805,203.290113 L49.3125189,191.971438 L45.8318517,184.186224 L45.0577917,177.942438 L43.8747664,170.564702 L74.6170665,170.564702 L76.0967777,175.103474 L79.5246512,180.182825 L85.4197014,183.077556 L90.6581763,184.186224 L95.6059139,180.182825 L98.7133073,175.103474 L100.358092,168.934789 L96.4074861,162.735617 L87.1544582,157.800521 L73.4935271,155.717771 L63.3586211,151.673475 L55.9756805,145.092851 L49.3125189,135.239015 L47.2602563,126.908019 L47.2602563,113.355649 L49.3125189,100.900051 L57.4992625,89.3590472 L71.7654624,81.3016855 L87.1544582,77.6157919 L106.247193,78.4426456 L118.288622,85.4158773 L127.578085,94.212351 L132.590513,105.087113 L132.590513,121.645006 Z M107.304555,118.000009 L108.723293,119.102728 L117.324207,119.102728 L124.12716,118.551369 L127.145325,118.000009 L127.145325,108.047278 L124.12716,100.914922 L114.573729,92.5854124 L98.846407,84.3243115 L92.6516967,83.0475959 L75.6878123,84.3243115 L64.2568579,91.5860497 L61.3539472,92.5854124 L61.3539472,95.9500821 L56.0321921,103.827499 L54.2766152,110.964317 L51.7715163,118.000009 L51.7715163,126.603897 L54.2766152,133.067037 L57.7171295,139.376258 L64.2568579,146.084777 L68.6714533,148.317729 L72.3447061,150.168483 L85.2308338,152.704068 L97.6700738,158.977597 L104.023165,166.971012 L104.023165,174.371055 L101.134382,179.959753 L96.3926146,183.983972 L92.6516967,185.900161 L81.9040862,185.900161 L76.6269455,181.937658 L72.3447061,176.032198 L71.2962676,174.371055 L49.9393513,176.032198 L48.9645266,178.152869 L51.7715163,186.82814 L54.2766152,192.768549 L59.1232269,198.11038 L68.6714533,205.278428 L78.2085262,206.84365 L88.0549257,207.849705 L98.846407,206.84365 L111.415772,198.11038 L119.257498,192.768549 L125.551847,181.937658 L127.145325,163.131199 L122.354481,152.704068 L113.226374,144.56417 L80.074152,130.565656 L75.6878123,126.603897 L75.6878123,111.919809 L78.2085262,106.690257 L83.6001772,102.39389 L92.6516967,102.39389 L97.6700738,105.325056 L102.700348,110.153822 L106.360217,115.826544 L106.360217,118.551369 L107.304555,118.000009 Z M58.6726214,9.644257 L49.7675859,9.644257 L42.7207404,14.9712171 L38.999899,21.0053155 L37.9804598,25.712879 L38.999899,29.9408375 L41.876041,34.7443219 L48.3265406,39.9790789 L55.1986463,43.6233323 L63.98471,45.7402859 L70.4701575,47.3441738 L82.0029815,48.4030224 L82.0029815,42.8552209 L79.7239289,34.7443219 L75.7205295,26.5456812 L71.3230362,18.7002379 L65.4584725,12.8460842 L58.6726214,9.644257 Z M95.4884293,47.8460859 L109.174642,47.0697952 L116.313691,45.3223976 L126.125886,42.0320852 L132.410568,37.899304 L136.702474,33.4601706 L139.4879,28.6860573 L139.4879,22.6701765 L137.967293,18.9723858 L134.075429,12.9799274 L128.874133,10.474085 L123.675068,9.52602883 L115.499478,10.474085 L106.560981,18.9723858 L98.7467681,33.4601706 L95.4884293,43.4679255 L95.4884293,47.8460859 Z"
    }
  })]), _c('g', {
    attrs: {
      "id": "Page-1"
    }
  }, [_c('use', {
    attrs: {
      "id": "Combined-Shape",
      "xlink:href": "#path-1"
    }
  })])]), _c('div', {
    staticClass: "l-header__logo-label"
  }, [_vm._v("佐藤物産館")])])])]), _c('md-button', {
    staticClass: "l-header__menu md-fab md-clean md-mini is-hide-min-md",
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleMenu.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.isOpen ? 'close' : 'menu'))])], 1), _c('nav', {
    staticClass: "l-header__nav"
  }, [_c('md-list', {
    staticClass: "l-header__list"
  }, [_vm._l((_vm.navItems), function(item, index) {
    return [_c('md-list-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== 0),
        expression: "index !== 0"
      }],
      key: index,
      staticClass: "l-header__item",
      class: (_vm.currentSection === (index + 1)) ? "is-current" : "",
      on: {
        "click": function($event) {
          return _vm.handleMove(item.target)
        }
      }
    }, [_c('span', {
      staticClass: "l-header__label"
    }, [_vm._v(_vm._s(item.label))]), _c('md-icon', {
      staticClass: "l-header__icon"
    }, [_vm._v("chevron_right")])], 1)]
  })], 2)], 1), _c('div', {
    staticClass: "l-header__sns"
  }, [_c('div', {
    staticClass: "l-header__btn-facebook"
  }, [_c('md-button', {
    staticClass: "md-fab",
    attrs: {
      "href": "https://www.facebook.com/SATOBUSSAN",
      "target": "_blank"
    }
  }, [_c('md-icon', {
    staticClass: "fa fa-facebook"
  })], 1)], 1), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-header__btn-like"
  }, [_c('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "src": "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FSATOBUSSAN&width=250&layout=button_count&action=like&size=small&share=true&height=46&appId=834694026693662",
      "width": "180",
      "height": "50",
      "scrolling": "no",
      "frameborder": "0",
      "allowfullscreen": "true",
      "allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    }
  })])
}]}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-wrap",
    attrs: {
      "id": "jsTargetTop"
    }
  }, [_c('section', {
    ref: "section1",
    staticClass: "p-home-section"
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isLoaded ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section1
    }
  }), _vm._m(0), _c('div', {
    staticClass: "p-home-section__btn-next",
    on: {
      "click": function($event) {
        return _vm.handleMove("#jsTargetAbout")
      }
    }
  }, [_c('div', {
    staticClass: "p-home-section__label-next"
  }, [_vm._v("寄り道する")]), _c('md-icon', {
    staticClass: "md-size-4x p-home-section__icon-next"
  }, [_vm._v("keyboard_arrow_down")])], 1)]), _c('section', {
    ref: "section2",
    staticClass: "p-home-section is-white",
    attrs: {
      "id": "jsTargetAbout"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section2 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section2
    }
  }), _vm._m(1)]), _c('section', {
    ref: "section3",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetShop"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section3 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section3
    }
  }), _c('div', {
    staticClass: "p-home-section__content--shop"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("おみやげ")]), _vm._m(2), _c('div', {
    staticClass: "p-home-section__slider"
  }, [_c('md-boards', {
    staticClass: "md-transparent",
    attrs: {
      "md-controls": true,
      "md-swipeable": true
    }
  }, _vm._l((_vm.shopItems), function(item, index) {
    return _c('md-board', {
      key: item.url,
      staticClass: "p-home-shop__wrap",
      attrs: {
        "id": "item_" + index
      }
    }, [_c('div', {
      staticClass: "p-home-shop__inner"
    }, [_c('div', {
      staticClass: "p-home-shop__capture"
    }, [_c('img', {
      staticClass: "p-home-shop__img",
      attrs: {
        "src": item.img
      }
    })]), _c('div', {
      staticClass: "p-home-shop__content"
    }, [_c('p', {
      staticClass: "p-home-shop__title u-elps-1"
    }, [_vm._v(_vm._s(item.name))]), _c('md-button', {
      staticClass: "p-home-shop__btn md-raised md-accent",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v("お取り寄せする")])], 1)])])
  }), 1)], 1), _vm._m(3)])]), _c('section', {
    ref: "section5",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetCompany"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section5 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section5
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("会社概要")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('md-list', {
    staticClass: "md-double-line"
  }, [_c('md-list-item', [_c('md-icon', [_vm._v("store")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("店名")]), _c('div', [_vm._v("佐藤物産館")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("domain")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("会社名")]), _c('div', [_vm._v("株式会社 佐藤物産")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("place")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("住所")]), _c('div', [_vm._v("〒964-0074"), _c('br'), _vm._v("福島県二本松市岳温泉一丁目14番地")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("phone")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("TEL")]), _c('div', [_vm._v("0243-24-2504")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("print")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("FAX")]), _c('span', [_vm._v("0243-24-2266")])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("email")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("EMAIL")]), _c('span', [_vm._v(_vm._s(_vm.config.contact.to))])]), _c('md-divider', {
    staticClass: "md-inset"
  })], 1), _c('md-list-item', [_c('md-icon', [_vm._v("face")]), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("代表取締役")]), _c('span', [_vm._v("佐藤はるみ")])])], 1)], 1)], 1)])]), _c('section', {
    ref: "section6",
    staticClass: "p-home-section is-white",
    attrs: {
      "id": "jsTargetAccess"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section6 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section6
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("アクセス")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('div', {
    staticClass: "p-home-map-frame"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "center": _vm.config.map.center,
      "zoom": 18,
      "map-type-id": _vm.config.map.type,
      "options": _vm.config.map.options
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.config.map.maker.pos,
      "clickable": true,
      "draggable": true
    },
    on: {
      "click": function($event) {
        _vm.center = _vm.config.map.maker.pos
      }
    }
  })], 1)], 1)])])]), _c('section', {
    ref: "section7",
    staticClass: "p-home-section",
    attrs: {
      "id": "jsTargetContact"
    }
  }, [_c('div', {
    staticClass: "p-home-section__filter"
  }), _c('img', {
    staticClass: "p-home-section__img",
    class: _vm.isOver.section7 ? "is-fade" : "",
    attrs: {
      "src": _vm.config.img.section7
    }
  }), _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("お問い合わせ")]), _c('div', {
    staticClass: "p-home-section__desc"
  }, [_c('form', {
    staticClass: "p-home-contact md-theme-default md-list",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-home-contact__type-wrap"
  }, [_c('div', {
    staticClass: "p-home-contact__label"
  }, [_vm._v("お問い合わせ種別")]), _c('div', {
    staticClass: "p-home-contact__type-list"
  }, _vm._l((_vm.config.contact.types), function(typeItem, index) {
    return _c('md-radio', {
      key: typeItem.id,
      staticClass: "p-home-contact__type-item md-primary",
      attrs: {
        "name": "type",
        "id": typeItem.id,
        "md-value": typeItem.id
      },
      model: {
        value: (_vm.contact.type.value),
        callback: function($$v) {
          _vm.$set(_vm.contact.type, "value", $$v)
        },
        expression: "contact.type.value"
      }
    }, [_vm._v(_vm._s(typeItem.label))])
  }), 1)]), _c('md-input-container', {
    staticClass: "p-home-contact__email-wrap",
    class: (_vm.contact.email.invalid.format || _vm.contact.email.invalid.require) ? "md-input-invalid" : "",
    attrs: {
      "md-clearable": "md-clearable"
    }
  }, [_c('label', [_vm._v("ご連絡先メールアドレス")]), _c('md-input', {
    attrs: {
      "required": "required"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleEmailValid()
      }
    },
    model: {
      value: (_vm.contact.email.value),
      callback: function($$v) {
        _vm.$set(_vm.contact.email, "value", $$v)
      },
      expression: "contact.email.value"
    }
  }), _c('ul', {
    staticClass: "p-home-contact__invalid-list"
  }, [(_vm.contact.email.invalid.format) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("メールアドレスの形式が不正です。")]) : _vm._e(), (_vm.contact.email.invalid.require) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("メールアドレスが入力されていません。")]) : _vm._e()])], 1), _c('md-input-container', {
    staticClass: "p-home-contact__content-wrap",
    class: _vm.contact.content.invalid.require ? "md-input-invalid" : "",
    attrs: {
      "md-clearable": "md-clearable"
    }
  }, [_c('label', [_vm._v("お問い合わせ内容")]), _c('md-textarea', {
    attrs: {
      "required": "required"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleContentValid()
      }
    },
    model: {
      value: (_vm.contact.content.value),
      callback: function($$v) {
        _vm.$set(_vm.contact.content, "value", $$v)
      },
      expression: "contact.content.value"
    }
  }), _c('ul', {
    staticClass: "p-home-contact__invalid-list"
  }, [(_vm.contact.content.invalid.require) ? _c('li', {
    staticClass: "p-home-contact__invalid-item md-error"
  }, [_vm._v("お問い合わせ内容が入力されていません。")]) : _vm._e()])], 1), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "href": _vm.mailTo
    }
  }, [_vm._v("メールで送信する")])], 1)])])]), _c('md-button', {
    staticClass: "md-fab md-clean p-home-btn-top",
    class: _vm.btnTop.isShow ? "is-active" : "",
    on: {
      "click": function($event) {
        return _vm.handleMove("#jsTargetTop")
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-size-2x p-home-icon-top"
  }, [_vm._v("arrow_upward")])], 1), _c('md-snackbar', {
    ref: "snackbar",
    staticClass: "p-home-snackbar",
    attrs: {
      "md-position": "top right",
      "md-duration": "10000"
    }
  }, [_c('div', {
    staticClass: "p-home-snackbar__lead-list"
  }, _vm._l((_vm.alertMessages), function(message) {
    return _c('div', {
      staticClass: "p-home-snackbar__lead-item"
    }, [_vm._v(_vm._s(message))])
  }), 0), _c('md-button', {
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("閉じる")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-section__content--firstView"
  }, [_c('h3', {
    staticClass: "p-home-copy"
  }, [_c('div', {
    staticClass: "p-home-copy__title"
  }, [_c('span', {
    staticClass: "p-home-copy__sp-br"
  }, [_vm._v("『少しだけ、")]), _c('span', {
    staticClass: "p-home-copy__sp-br"
  }, [_vm._v("寄り道する。』")])]), _c('div', {
    staticClass: "p-home-copy__desc"
  }, [_vm._v("福島に来たら少しだけ寄り道していきませんか?"), _c('br'), _vm._v("アクティビティや温泉で一汗かいたら、冷たいビールやアイスクリーム。"), _c('br'), _vm._v("旅の合間にふらっとお立ち寄りください。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-home-section__content"
  }, [_c('h3', {
    staticClass: "p-home-section__title"
  }, [_vm._v("当店について")]), _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("当店は百名山安達太良山の麓「二本松」で昭和30年に物産店として創業いたしました。"), _c('br'), _c('br'), _vm._v("現在は4代目当主となる店主が元料理人だったこともあり、\n食品加工、その製品の卸売もおこなっております。"), _c('br'), _c('br'), _vm._v("食感にこだわった「福島の温泉たまご とろんたま」。"), _c('br'), _vm._v("酪農が盛んな、あだたら高原でとれた牛乳と\n本場ヨーロッパのクラシックな製法でつくられた「あだたら山のミルクジャム」\nなどの製品を提供しております。"), _c('br'), _c('br'), _vm._v("また、修学旅行などの団体様向けへのスキー用品レンタル、\n登山用品等のアクティビティツールのレンタルも取り扱っております。"), _c('br'), _c('br'), _vm._v("「温故知新」の理念のもと"), _c('br'), _vm._v("その土地の 文化、人、技術、素材と共に歩む企業を目指しております。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("自社商品のほか、店主が厳選した福島のおみやげや地酒を取り揃えております。"), _c('br'), _c('br'), _vm._v("お土産のお取り寄せもご対応させていただいております。"), _c('br'), _vm._v("旅のお手荷物にならないよう、ご自宅からご注文いただけます。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-home-section__desc"
  }, [_vm._v("また、店内にはカフェスペースを常設しております。"), _c('br'), _vm._v("温泉たまごや自社商品を使用したメニューをお楽しみいただけます。"), _c('br'), _vm._v("登山の帰り道や日帰り温泉の後にも、ぜひお立寄りください。")])
}]}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "l-footer"
  }, [_vm._v("Copyright " + _vm._s(_vm.year) + " (株) 佐藤物産")])
},staticRenderFns: []}

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container",
    attrs: {
      "id": "app"
    }
  }, [_c('GlobalHeader', {
    attrs: {
      "current-section": _vm.currentSection
    },
    on: {
      "currentUpdate": _vm.handleCurrentUpdate
    }
  }), _c('main', {
    staticClass: "l-content"
  }, [_c('router-view', {
    attrs: {
      "currentSection": _vm.currentSection
    },
    on: {
      "currentUpdate": _vm.handleCurrentUpdate
    }
  })], 1), _c('GlobalFooter')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  URL: {
    ASSETS: {
      IMG: {
        BG_SECTION_1: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmidorigaike.jpg?alt=media&token=10f4c617-7ad4-4403-810c-f657342302f7',
        BG_SECTION_2: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_3.jpg?alt=media&token=00c1b084-16d5-4208-9f86-ae0b55fe0795',
        BG_SECTION_3: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fjam_2.JPG?alt=media&token=1ca56571-198d-4b98-a0b0-f59af774aba1',
        BG_SECTION_4: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fski_2.jpg?alt=media&token=5f7787eb-934d-4824-94a0-1e8d88193b2d',
        BG_SECTION_5: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_5.jpg?alt=media&token=11967597-570a-47b7-a617-3bd4714a1ddc',
        BG_SECTION_6: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_4.jpg?alt=media&token=a425806d-5429-437a-b922-8669aef1b66b',
        BG_SECTION_7: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fnews.jpg?alt=media&token=520f26ab-8596-46e8-880a-8a7248f9e079',

        SHOP_ITEM_1: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fshop_2020_1.jpg?alt=media&token=0d55da92-af1b-433d-8e0c-aab981bb1db2',
        SHOP_ITEM_2: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fshop_2020_3.jpg?alt=media&token=c617b064-b8aa-4c6d-baec-d07e015d78fb'
      }
    }
  },
  CONTACT: {
    TO: 'satobussan@gmail.com',
    SUBJECT_PREFIX: '佐藤物産HPからの問い合わせ'
  },
  API: {
    TIMEOUT: 300000,
    BASE_URL: 'https://us-central1-omiyage-sato.cloudfunctions.net/',
    CONTACT: 'contact'
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_axios__);
/**
 * ApiClient
 * axiosのラッパー関数
 */



// エラーハンドリング関数
// 下記のステータスコードを参考にAPIのレスポンスを作成
// 失敗モーダル表示など共通処理が出てきたら記述
var handleError = function handleError(status) {
  // ステータス毎に処理を変更 - https://developer.mozilla.org/ja/docs/Web/HTTP/Status
  switch (status) {
    case '200': // リクエスト成功
    case '201': // 作成成功
    case '204':
      // 削除成功
      /*
      console.error('status >= 200 && status < 300で例外発生');
      */
      break;
    case '301': // リダイレクト
    case '304': // キャッシュされている
    case '400': // 不正なパラメータ
    case '401': // 認証失敗
    case '403': // 認証エラーによるレスポンス拒否
    case '404': // リソースが見つからない
    case '409': // リクエストの矛盾（同一primaryKeyの登録など）
    case '500': // 想定しないサーバーエラー
    case '501': // HTTPメソッドが不正（想定しないHTTPメソッド）
    case '502': // サーバー側のレスポンスが不正
    case '503': // サーバーダウン
    case '504':
      // サーバーのタイムアウト
      /*
       必要に応じて「リクエストが失敗しました」的なモーダルを表示する
       console.error('リクエストが失敗');
       */
      break;
    default:
      break;
  }
};

var modifyMethodGroup = ['post', 'put', 'patch', 'delete'];

// axiosの設定 - application_xxxから1度だけ呼び出す
var apiSetting = function apiSetting() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default.a.defaults.timeout = config.CONST.API.TIMEOUT;
  __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default.a.defaults.baseURL = config.CONST.API.BASE_URL;

  _.forEach(modifyMethodGroup, function (method) {
    __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default.a.defaults.headers[method]['Content-Type'] = 'application/x-www-form-urlencoded';
  });

  // respond_toの複数format対応
  __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default.a.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

  // Authorizationヘッダを利用する場合(jwtなど)
  /*
   axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  */

  /*
   axios.defaults.withCredentials = true;
  */
};

/* harmony default export */ __webpack_exports__["b"] = (function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var reformatParams = {
    method: params.method || 'get',
    url: params.url || '',
    headers: params.headers || {},
    // body params
    data: params.data || {},
    // query params
    params: params.params || {},
    // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: params.responseType || 'json',
    // デフォルトは200 <= status < 300 でresolve
    validateStatus: params.validateStatus || __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default.a.defaults.validateStatus,
    // リクエストキャンセル - https://github.com/mzabriskie/axios#cancellation
    cancelToken: params.cancelToken || null,
    // 成功時の共通処理を握りつぶすコールバック
    success: params.success || null,
    // 失敗時の共通処理を握りつぶすコールバック
    error: params.error || null
    // 成功時にpublishしたい内容
    /*
     publish: params.publish || null,
    */
  };

  if (params.contentType === 'json') {
    reformatParams.headers = _.extend(reformatParams.headers, {
      'Content-Type': 'application/json'
    });
  }

  /*
   _.forEach(modifyMethodGroup, method => {
     if (params.method === method) {
       // CSRFトークンの付与
       const token = DIVER.$('[name=csrf-token]').attr('content')[0];
       reformatParams.headers = _.extend(reformatParams.headers, {
         'X-CSRF-TOKEN': token
       });
     }
   });
  */

  // レスポンスの前処理
  // interceptorsは複雑になるため利用しない
  return __WEBPACK_IMPORTED_MODULE_0__node_modules_axios___default()(reformatParams).then(function (response) {
    var ret = void 0;
    if (params.success) {
      ret = params.success(response);
    } else {
      // 共通のデータ加工処理はここに記述
      ret = response.data;
    }
    return ret;

    /*
     if (params.publish) {
       PubSub.publish(params.publish, response);
     }
    */
  }).catch(function (error) {
    if (params.error) {
      params.error(error);
    } else {
      // 共通のエラーハンドリング
      handleError(error.response.status);
      throw error.response.data;
    }
  });
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home_index_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_home_index_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_home_index_vue___default.a
  }]
}));

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(256),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[114]);


// WEBPACK FOOTER //
// static/js/app.afa449f295221a860195.js